export default class FactureAvoirSelectController {

    static $inject = [
        '$scope',
        '$stateParams',
        'AvoirsService',
        'notification',
        'ModalService',
        '$uibModal',
        'moment',
        '$translate'
    ];

    constructor($scope, $stateParams, AvoirsService, notification, ModalService, $uibModal, moment, $translate) {
        this.$scope = $scope;
        this.$stateParams = $stateParams;
        this.AvoirsService = AvoirsService;
        this.notification = notification;
        this.ModalService = ModalService;
        this.$uibModal = $uibModal;
        this.moment = moment;
        this.$translate = $translate;
    }

    async $onInit() {
        try {
            this.startLoading();
            this.ticketCheckeds = [];
            this.isDisabled = true;
            this.isForTicketDelete = false;
            this.disabledTitle = 'Des modifications sont obligatoires pour valider l’opération.';
            if (this.avoirData) {
                this.isForTicketDelete = true;
                this.disabledTitle = 'Veuillez modifier le client sur chacun des tickets';
                this.avoirResult = this.avoirData;
                this.ticketSelecteds = this.avoirResult.ticketRefacts.filter((element) => element.isDelete);
                this.ticketsFactures = this.$translate.instant('FACTURES.AVOIR.NB_TICKETS', { nbt: this.ticketSelecteds.length });
            }
            else {
                this.avoirResult = await this.AvoirsService.getAvoir(this.idFactures, false);
                this.ticketSelecteds = this.avoirResult.ticketRefacts;
                this.title = this.$translate.instant('FACTURES.AVOIR.POUR_CLIENT', { client: this.avoirResult.client });
                this.ticketsFactures = this.$translate.instant('FACTURES.AVOIR.TICKETS_FACTURES', { nbt: this.avoirResult.nbTickets, nbf: this.avoirResult.nbFactures });
                this.sommeFactures = this.avoirResult.nbFactures == 1 ?
                    this.$translate.instant('FACTURES.AVOIR.TOTAL_FACTURE') :
                    this.$translate.instant('FACTURES.AVOIR.SOMME_FACTURES', { nbf: this.avoirResult.nbFactures });
                if (this.avoirResult.htAvoir != '0,00') {
                    this.isDisabled = false;
                }
            }
        } catch (ex) {
            this.notification.error(ex.data);
        } finally {
            this.stopLoading();
        }
    }

    valider() {
        let ticketSelecteds = this.avoirResult.ticketRefacts.filter((element) => element.isDelete);
        let idClients = ticketSelecteds.filter((element) => element.deleteOption.idClient).map(x => x.deleteOption.idClient);
        let uniqueClients = []
        idClients.forEach(e => {
            if (!uniqueClients.includes(e)) uniqueClients.push(e)
        });
        if (!this.isForTicketDelete) {
            this.modalInstance.close();
            var _this = this;
            this.$uibModal.open({
                template:
                    '<facture-avoir-partiel-refact avoir-result="$ctrl.avoirResult" date="$ctrl.date" modal-instance="$ctrl.uibModalInstance"></facture-avoir-partiel-refact>',
                controller: [
                    '$uibModalInstance',
                    function ($uibModalInstance) {
                        var $ctrl = this;
                        $ctrl.avoirResult = _this.avoirResult;
                        $ctrl.date = _this.date;
                        $ctrl.uibModalInstance = $uibModalInstance;
                    },
                ],
                controllerAs: '$ctrl',
                size: 'l',
                backdrop: false
            }); 
        }
        else {
            this.modalInstance.close();
            var _this = this;
            this.$uibModal.open({
                template:
                    '<facture-avoir-fact-client avoir-result="$ctrl.avoirResult" date="$ctrl.date" id-clients="$ctrl.idClients" modal-instance="$ctrl.uibModalInstance"></facture-avoir-fact-client>',
                controller: [
                    '$uibModalInstance',
                    function ($uibModalInstance) {
                        var $ctrl = this;
                        $ctrl.avoirResult = _this.avoirResult;
                        $ctrl.date = _this.date;
                        $ctrl.idClients = uniqueClients;
                        $ctrl.uibModalInstance = $uibModalInstance;
                    },
                ],
                controllerAs: '$ctrl',
                size: 'l',
                backdrop: false
            }); 
        }
    }

    async annuler() {
        this.modalInstance.close();
        if (this.avoirResult) {
            await this.AvoirsService.deleteTicketFictifs(this.avoirResult.idTickets);
        }
    }

    async deleteTicket(ticket) {
        ticket.isDelete = !ticket.isDelete;
        if (ticket.isDelete) {
            ticket.update = {};
            ticket.isUpdate = false;
        }
        this.GetValoAvoir();
    }

	getTicketCheckeds() {
		this.ticketCheckeds = [];
		this.avoirResult.ticketRefacts.forEach(function (element) {
			if (element.isChecked == true) {
				this.ticketCheckeds.push(element);
			}
		}, this);
	}

    checkAllTickets(value) {
		this.avoirResult.ticketRefacts.forEach(function (element) {
            element.isChecked = value;
		}, this);
        this.getTicketCheckeds();
	}

    update(ticket) {
        this.ticketCheckeds = [];
        this.ticketCheckeds.push(ticket)
        this.updateTicket();
    }

    updateMulti() {
        this.getTicketCheckeds();
        if (this.ticketCheckeds.length > 0)
            this.updateTicket();
    }

    updateTicket() {
        var _this = this;
        this.$uibModal.open({
            template:
                '<facture-avoir-update tickets="$ctrl.tickets" id-client="$ctrl.idClient" id-client-divers="$ctrl.idClientDivers" id-site="$ctrl.idSite" id-societe="$ctrl.idSociete" date="$ctrl.date" is-Delete="$ctrl.isDelete" modal-instance="$ctrl.uibModalInstance"></facture-avoir-update>',
            controller: [
                '$uibModalInstance',
                function ($uibModalInstance) {
                    var $ctrl = this;
                    $ctrl.tickets = _this.ticketCheckeds;
                    $ctrl.idClient = _this.avoirResult.idClient;
                    $ctrl.idClientDivers = _this.avoirResult.idClientDivers;
                    $ctrl.idSite = _this.avoirResult.idSite;
                    $ctrl.idSociete = _this.avoirResult.idSociete;
                    $ctrl.date = _this.date;
                    $ctrl.isDelete = _this.isForTicketDelete
                    $ctrl.uibModalInstance = $uibModalInstance;
                },
            ],
            controllerAs: '$ctrl',
            size: 'l',
            backdrop: false
        })
        .result.then(async function (result) {
            if (result) {
                _this.getDisabled();
                //_this.checkAllTickets(false);
                _this.GetValoAvoir();
            }
        });
    }

    async GetValoAvoir() {
        if (!this.isForTicketDelete) {
            try {
                this.isDisabled = true;
                this.startLoadingPrix();
                const valo = await this.AvoirsService.getValorisation(this.avoirResult);
                if (valo) {
                this.avoirResult.htAvoir = valo.montantHt;
                this.avoirResult.ttcAvoir = valo.montantTtc;
                }
            } catch (ex) {
                this.notification.error(ex.data);
            } finally {
                this.getDisabled();
                this.stopLoadingPrix();
            }
        }
    }

    getDisabled() {
        if (this.isForTicketDelete) {
            let ticketNotUpdateds = this.ticketSelecteds.filter((element) => !element.isOk);
            if (ticketNotUpdateds.length > 0) {
                this.isDisabled = true;
            }
            else {
                this.isDisabled = false;
            }
        }
        else {
            let ticketUpdateds = this.ticketSelecteds.filter((element) => element.isUpdate); 
            let ticketDeleteds = this.ticketSelecteds.filter((element) => element.isDelete); 
            if (ticketUpdateds.length == 0 && ticketDeleteds.length == 0) {
                this.isDisabled = true;
            }
            else {
                this.isDisabled = false;
            }
            if (this.avoirResult.htAvoir != '0,00') {
                this.isDisabled = false;
            }
        }
    }

    startLoading() {
        this.loading = true;
    }

    stopLoading() {
        this.loading = false;
    }

    startLoadingPrix() {
        this.loadingPrix = true;
    }

    stopLoadingPrix() {
        this.loadingPrix = false;
    }
}
